<template>
    <v-container fluid fill-height>
            <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Login form</v-toolbar-title>
                    
                </v-toolbar>
                <v-card-text>
                    <v-form ref="form" v-model="vaild" lazy-validation>
                    <v-text-field :rules="userRule" prepend-icon="person" v-model="username" label="Benutzername" type="text" required></v-text-field>
          
                    <v-text-field :rules="pwRule" prepend-icon="lock" v-model="password" label="Passwort" type="password" required></v-text-field>
         
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :disabled="loading" @click="onSubmit">Login</v-btn>

                    <div v-if="error" class="alert alert-danger">{{error}}</div>

                </v-card-actions>
                </v-card>
                
            </v-flex>
            </v-layout>
    </v-container>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { router } from '@/router';
import { authenticationService } from '@/services';


export default {
    data () {
        return {
            username: '',
            password: '',
            submitted: false,
            loading: false,
            returnUrl: '',
            valid: true,
            error: '',

            userRule: [
                v => !!v || 'Username is required',
                ],

            pwRule: [
                v => !!v || 'Password is required',
                ],


        };
    },

    created () {
        // redirect to home if already logged in
        if (authenticationService.currentUserValue) { 
            return router.push('/');
        }

        // get return url from route parameters or default to '/'
        this.returnUrl = this.$route.query.returnUrl || '/';
    },
    methods: {

        validate () {
            if (!this.$refs.form.validate()) {
            return;
            }
        },

        async onSubmit () {
            this.submitted = true;

            // stop here if form is invalid
            if (!this.$refs.form.validate()) {
                return;
            }
   

            this.loading = true;

            await authenticationService.login(this.username, this.password)
                .then(
                    user => router.push(this.returnUrl),
                    error => {
                        this.error = error;
                         this.loading = false;
                    }
                );

            if (authenticationService.currentUserValue) { 
                return router.push('/');
            }
        }
    }
};
</script>